import React, { memo } from "react";

import { formatCurrency } from "helpers";
import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";
import CheckIcon from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleEditCard/components/VehicleWizardIntro/scenes/CheckIcon";

import { NEW_PRICE_INTRO_SAMPLE } from "../consts";
import { NewPriceSceneProps } from "../types";

/** Korak "Dodatna oprema": označena oprema s cijenama i kako se zbraja s osnovnom cijenom. */
const NewPriceEquipmentScene: React.FC<NewPriceSceneProps> = ({ formValues, equipment, selectedEquipment }) => {
  const selected = equipment
    .filter((item) => selectedEquipment.includes(item.id))
    .map((item) => ({ name: item.name ?? "", price: item.finalPriceEur ?? item.priceEur ?? 0 }));
  const items = selected.length > 0 ? selected : NEW_PRICE_INTRO_SAMPLE.equipment;
  // Slobodno upisana oprema pribraja se označenoj.
  const equipmentTotal =
    items.reduce((total, item) => total + item.price, 0) + (Number(formValues.additionalEquipmentFreePrice) || 0);

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Dodatna oprema</div>
          <div className="text-sm font-bold text-slate-800">
            {selected.length > 0 ? `Označeno: ${selected.length}` : "Oprema vozila"}
          </div>
          <div className="mt-3 space-y-2">
            {items.slice(0, 4).map((item) => (
              <div key={item.name} className="flex items-center gap-2 rounded-md bg-slate-50 px-2 py-2">
                <CheckIcon />
                <span className="flex-1 text-[0.7rem] font-medium text-slate-700 truncate">{item.name}</span>
                <span className="text-[0.65rem] font-semibold text-slate-500">{formatCurrency.format(item.price)}</span>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Cijena novog vozila</div>
          <div className="mt-2 space-y-1">
            <div className="flex items-center justify-between text-[0.7rem]">
              <span className="text-slate-500">Osnovna cijena</span>
              <span className="font-semibold text-slate-800">{formatCurrency.format(NEW_PRICE_INTRO_SAMPLE.basePrice)}</span>
            </div>
            <div className="flex items-center justify-between text-[0.7rem]">
              <span className="text-slate-500">Oprema</span>
              <span className="font-semibold text-emerald-600">+ {formatCurrency.format(equipmentTotal)}</span>
            </div>
          </div>
          <div className="mt-2 pt-2 border-t border-slate-100 text-lg font-bold text-slate-800">
            {formatCurrency.format(NEW_PRICE_INTRO_SAMPLE.basePrice + equipmentTotal)}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Izračun u trenutku"
          subtitle="Cijena s PDV-om i PPMV-om"
          iconClassName="bg-emerald-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#047857" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(NewPriceEquipmentScene);
